/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportLinkDelete
 */
export interface SupportLinkDelete {
    /**
     * 
     * @type {string}
     * @memberof SupportLinkDelete
     */
    id: string;
}

/**
 * Check if a given object implements the SupportLinkDelete interface.
 */
export function instanceOfSupportLinkDelete(value: object): value is SupportLinkDelete {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SupportLinkDeleteFromJSON(json: any): SupportLinkDelete {
    return SupportLinkDeleteFromJSONTyped(json, false);
}

export function SupportLinkDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportLinkDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function SupportLinkDeleteToJSON(json: any): SupportLinkDelete {
    return SupportLinkDeleteToJSONTyped(json, false);
}

export function SupportLinkDeleteToJSONTyped(value?: SupportLinkDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

